import React, { useCallback, useEffect } from 'react';
import { When } from 'react-if';
import PropTypes from 'prop-types';
import './styles.css';
import { useToggle } from 'react-use';

const Checkbox = ({ initialValue, value, text, onClick }) => {
    const [isChecked, toggleCheckStatus] = useToggle(initialValue);

    useEffect(() => {
        if (value) {
            toggleCheckStatus(value);
        }
    }, [value, toggleCheckStatus]);

    const handleClick = useCallback(() => {
        onClick();
        toggleCheckStatus();
    }, [onClick, toggleCheckStatus]);

    return (
        <div
            className="align-items-center cursor-pointer d-flex flex-wrap justify-content-center"
            onClick={handleClick}
        >
            <div className="checkbox__container d-flex justify-content-center align-items-center">
                <When condition={isChecked}>
                    <div className="checkbox__container--checked" />
                </When>
            </div>
            <div className="checkbox__text ml-2">{text}</div>
        </div>
    );
};

Checkbox.propTypes = {
    value: PropTypes.bool,
    text: PropTypes.string.isRequired,
    initialValue: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
    initialValue: false,
};

export default React.memo(Checkbox);
